import { SelectPickerItem } from '@/v2/shared/types/SelectPicker';

export const mapAgentEmailsToSelectPicker = (data: any[]): SelectPickerItem[] =>
  data.map(({email, agentName}) => ({
    value: email,
    label: agentName
  }));
